import { User, UserHttp } from '@data/models/user.interface';
import day from '@plugins/dayjs';

// eslint-disable-next-line complexity
export const toUser = (user: Partial<UserHttp>): User => {
  return {
    id: user.attributes?.id || '',
    avatar: user.attributes?.avatar || '',
    email: user.attributes?.email || '',
    fullname: `${
      user.attributes?.first_name
    } ${user.attributes?.last_name.toUpperCase()}`,
    firstname: user.attributes?.first_name || '',
    lastname: user.attributes?.last_name || '',
    emulateBy: user.attributes?.emulate_by || '',
    online: user.attributes?.online || false,
    hierarchy: user.attributes?.hierarchy || 0,
    initials: user.attributes?.initials || '',
    lastConnection:
      (user.attributes?.last_connection &&
        day(user.attributes.last_connection)) ||
      null,
    otherRole: user.attributes?.other_role || null,
    roles:
      (user.attributes?.roles || []).filter((role) =>
        role.startsWith('nina.'),
      ) || [],
    permissions: user.attributes?.permissions || [],
    service: user.attributes?.service || '',
    title: user.attributes?.title || '',
    managerId: user.attributes?.manager_repository_id || '',
    expiresAt: day(user.attributes?.expires_at),
    isAuthenticated: (user.attributes?.id && true) || false,
    regions: user.attributes?.regions || [],
    scopes: user.attributes?.scopes || [],
    payrollAnalyticCode: user.attributes?.code_analytique_paie || '',
    analyticalLabel: user.attributes?.libelle_analytique_paie || '',
    principalBu: user.attributes?.bu_principale || '',
    groups: user.attributes?.groups || [],
  };
};
